import { lazy } from "react";
import { routeProps } from "Services/Share.props";
import { STOCK_ACTIONS } from "../../Constants";
import RenderSubSection from "./RenderSubSections";

const StockList = lazy(() => import("pages/StockManagement/StockList"));
const CreateAddStock = lazy(() => import("pages/StockManagement/CreateStock"));
const CreateDeductStock = lazy(
    () => import("pages/StockManagement/CreateStock")
);
const CreateInventoryStock = lazy(
    () => import("pages/StockManagement/CreateStock")
);
const StockUploadImage = lazy(
    () => import("pages/StockManagement/StockUploadImage")
);

const stockAddList = {
    name: "اضافه",
    path: "/stock-add-list",
    group: "stock-add-list",
    exact: true,
    component: (props: routeProps) => (
        <StockList
            titleBtn="اضافه کردن"
            titleKey="اضافه"
            redirectKey="add"
            {...props}
        />
    ),
};

const stockAdd = {
    name: "اضافه کردن موجودی",
    path: "/create-stock-add",
    group: "create-stock-add",
    isHide: true,
    component: () => (
        <CreateAddStock
            title="اضافه کردن"
            mainTitle="اضافه کردن مورد"
            actionType={STOCK_ACTIONS.add}
        />
    ),
};

const stockDeductList = {
    name: "کسر",
    path: "/stock-deduct-list",
    group: "stock-deduct-list",
    exact: true,
    component: (props: routeProps) => (
        <StockList
            titleBtn="کسر کردن"
            titleKey="کسر"
            redirectKey="deduct"
            {...props}
        />
    ),
};

const stockDeduct = {
    name: "کسر کردن موجودی",
    path: "/create-stock-deduct",
    group: "create-stock-deduct",
    isHide: true,
    component: () => (
        <CreateDeductStock
            title="کسر کردن"
            mainTitle="کسر کردن مورد"
            actionType={STOCK_ACTIONS.deduct}
        />
    ),
};

const stockInventoryList = {
    name: "انبارگردانی",
    path: "/stock-inventory-list",
    group: "stock-inventory-list",
    exact: true,
    component: (props: routeProps) => (
        <StockList
            titleBtn="انبارگردانی"
            titleKey="انبارگردانی"
            redirectKey="inventory"
            {...props}
        />
    ),
};

const stockInventory = {
    name: "ست کردن موجودی",
    path: "/create-stock-inventory",
    group: "create-stock-inventory",
    isHide: true,
    component: () => (
        <CreateInventoryStock
            title="انبارگردانی"
            mainTitle="انبارگردانی"
            actionType={STOCK_ACTIONS.inventory}
        />
    ),
};

const stockUploadImage = {
    name: "نمایش عکس استاک",
    path: "/stock-upload-image",
    group: "stock-upload",
    isHide: true,
    component: (props: any) => <StockUploadImage {...props} />,
};

const subSections = {
    add: {
        list: { ...stockAddList },
        create: { ...stockAdd },
        update: { ...stockAdd },
        view: { ...stockUploadImage },
        file: { ...stockUploadImage },
    },
    deduct: {
        list: { ...stockDeductList },
        create: { ...stockDeduct },
        update: { ...stockDeduct },
        view: { ...stockUploadImage },
        file: { ...stockUploadImage },
    },
    inventory: {
        list: { ...stockInventoryList },
        create: { ...stockInventory },
        update: { ...stockInventory },
    },
};

const stockSection = {
    title: "مدیریت استاک",
    key: "stock",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default stockSection;
